/* eslint-disable camelcase */
import { PaymentProvider } from '@walletFederation/src/modules/payments/enums';
import WithdrawalResponse from '@core/models/user/withdrawal/WithdrawalResponse';
import { PaymentStatus } from '@superbet-group/web.types';

// Following Dtos have only the necessary fields typed, the payload they describe contains more fields
export type NuveiDepositDto = {
    kind: typeof TransactionDtoType.NuveiDeposit;
    transactionStatus: OnlineTransactionDtoStatus;
    PPP_TransactionID: string;
    productId: string;
    payment_method: 'cc_card' | 'apmgw_Neteller' | string;
    totalAmount: string;
    messageForAnalytics: string;
};

export type NuveiWithdrawalDto = {
    kind: typeof TransactionDtoType.NuveiWithdrawal;
    transactionStatus?: OnlineTransactionDtoStatus;
    status?: OnlineTransactionDtoStatus;
    wd_id?: string;
    transactionCode?: string;
    payment_method: 'cc_card' | 'apmgw_Neteller' | string;
    messageForAnalytics: string;
    wd_amount?: string;
    amount?: string;
};

export type PixDepositDto = {
    kind: typeof TransactionDtoType.PixDeposit;
    provider: PaymentProvider;
    transactionStatus: OnlineTransactionDtoStatus;
    PPP_TransactionID: string;
    productId: string;
    payment_method: 'cc_card' | 'apmgw_Neteller' | string;
    totalAmount: string;
    messageForAnalytics: string;
};

export type PixWithdrawalDto = {
    kind: typeof TransactionDtoType.PixWithdrawal;
    provider: PaymentProvider;
    transactionStatus?: OnlineTransactionDtoStatus;
    status?: OnlineTransactionDtoStatus;
    wd_id?: string;
    transactionCode?: string;
    payment_method: 'cc_card' | 'apmgw_Neteller' | string;
    messageForAnalytics: string;
    wd_amount?: string;
    amount?: string;
};

export type BankWithdrawalDto = WithdrawalResponse & {
    kind: typeof TransactionDtoType.BankWithdrawal;
    amount: string;
    status: PaymentStatus;
    transactionCode: string;
};
export type MonriDepositDto = {
    kind: typeof TransactionDtoType.MonriDeposit;
    acquirer: string;
    amount: string;
    order_number: string;
    response_code?: 'N/A' | '1000' | string;
    messageForAnalytics: string;
};

export type TransaksDepositDto = {
    kind: typeof TransactionDtoType.TransaksDeposit;
    amount: string;
    payment_id: string;
    customer_id: string;
    response: 'successful' | 'error';
    reason?: string;
    declined_error_reason?: string;
    confirm_error_reason?: string;
};

export type OnlineTransactionDtoStatus = 'success' | 'cancel' | 'pending' | 'failed';

export type OnlineTransactionDto =
    | NuveiDepositDto
    | MonriDepositDto
    | NuveiWithdrawalDto
    | BankWithdrawalDto
    | TransaksDepositDto
    | PixDepositDto
    | PixWithdrawalDto;

export const TransactionDtoType = {
    NuveiDeposit: 'NuveiDeposit',
    MonriDeposit: 'MonriDeposit',
    NuveiWithdrawal: 'NuveiWithdrawal',
    BankWithdrawal: 'BankWithdrawal',
    TransaksWithdrawal: 'TransaksWithdrawal',
    TransaksDeposit: 'TransaksDeposit',
    OtherWithdrawal: 'OtherWithdrawal',
    PixDeposit: 'PixDeposit',
    PixWithdrawal: 'PixWithdrawal',
} as const;

export type TransactionDtoType = typeof TransactionDtoType[keyof typeof TransactionDtoType];
